export default __webpack_public_path__ + "static/media/facebook.7c97119e.svg";